import moment from 'moment-timezone'; // Use moment-timezone instead of moment

export const getBrowserTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };
  
export const getUserTimeZone = () =>{
    const user = JSON.parse(localStorage.getItem("user") ?? "{timezone:''}"); 
    return user.timezone || getBrowserTimezone();
}

export const toUserTimezone = (tzString, date) => {
    // Validate tzString and the date
    if (!tzString || !moment.tz.names().includes(tzString)) {
        console.error("Invalid timezone string provided.");
        return moment(date); // Fallback to moment object with original date
    }
    const parsedDate = moment(date);
    if (!parsedDate.isValid()) {
        console.error("Invalid date provided.");
        return moment(date); // Fallback to moment object with original date
    }

    // Convert the moment object to the specified timezone
    return parsedDate.tz(tzString);
};
export const getFirstOfTheDate = (date, addDays = 0) => {
    const utcDate = moment(date).utc().add(addDays, 'days');
    utcDate.hour(0);
    utcDate.minute(0);
    utcDate.second(0);
    return utcDate;
}

export const getEndofTheDate = (date, addDays = 0) => {
    const utcDate = moment(date).utc().add(addDays, 'days');;
    utcDate.hour(23);
    utcDate.minute(59);
    utcDate.second(59);
    return utcDate;
}

